export const UPLOADRATES_SUCCESS = "UPLOADRATES_SUCCESS";
export const UPLOADRATES_ERROR = "UPLOADRATES_ERROR";

export const EXPORT_SUCCESS = "EXPORT_SUCCESS";
export const EXPORT_ERROR = "EXPORT_ERROR";